import { WidgetProps } from '@highimpact-front/remote-widget-core';
import { forwardRef, type LegacyRef } from 'react';
import { useEntityPropertyDisplayText } from '../../../../hooks/useEntityPropertyDisplayText';
import TextWidget from './TextFromPropertyDisplayer';
import type { EntityPropertyTable } from './resolveEntityPropertyText';

interface TextFromExternalProps extends WidgetProps {
  name: string;
  table: EntityPropertyTable;
  row_id: number;
  property: string;
  gridId: number;
  gridType: 'reports' | 'grids';
}

function TextFromExternalWidget(
  { table, row_id, property, name, gridType, ...props }: TextFromExternalProps,
  ref: LegacyRef<HTMLDivElement>
) {
  const { text, loading, error } = useEntityPropertyDisplayText(
    table,
    row_id,
    property
  );

  if (loading) {
    return <p>Chargement du texte...</p>;
  }

  if (error || text === undefined) {
    return <p>Impossible de charger la propriété de l&apos;entité.</p>;
  }

  return (
    <TextWidget
      gridType={gridType}
      name={name}
      text={text}
      {...props}
      ref={ref}
    />
  );
}

export default forwardRef(TextFromExternalWidget);
